var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-top"},[_c('search-form',{attrs:{"claim-type":_vm.ClaimType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }